import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(Loading);

Vue.prototype.$liff = window.liff;
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount("#app");
